import { useStore } from '../../store/reducers';

export function useIsChildAccount() {
  const user = useStore((s) => s.users.getter.currentUser());
  return user?.parentId != null;
}
